import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// Module
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { TabViewModule } from 'primeng/tabview'; 
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { GenericIntegrationsRoutingModule } from './generic-integrations-routing.module';
// Component
import { GenericIntegrationsComponent } from './generic-integrations.component';
import { TableLikeComponent } from './components/table-like/table-like.component';
import { EditableTableComponent } from './components/common/editable-table/editable-table.component';
import { IntegrationBaseTableComponent } from './components/base-table/base-table.component';
import { StaticFormComponent } from './components/components/static-form/static-form.component';
import { CreateUpdateFormComponent } from "./components/common/create-update-form/create-update-form.component";
import { OutgoingEventsHybridTabsComponent } from './components/outgoing-events-hybrid-tabs/outgoing-events-hybrid-tabs.component';
// Guard & Services
import { GenericIntegrationLoaderGuard } from './providers/generic-integration-loader.guard';
import { SelectedGenericIntegrationService } from './services/selected-generic-integration.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { GenericIntegrationService } from '../service/generic-integration.service';
import { GenericFormModule, GenericFormService } from '@cv-invision/cv.invision-views.ux';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		TableModule,
		ButtonModule,
		InputTextModule,
		ToastModule,
		AutoCompleteModule,
		ConfirmDialogModule,
		DropdownModule,
		PanelModule,
		GenericIntegrationsRoutingModule,
		ReactiveFormsModule,
		GenericFormModule,
		TabViewModule,
		ReactiveFormsModule,
    	CheckboxModule,
	],
	declarations: [
		GenericIntegrationsComponent,
		TableLikeComponent,
		EditableTableComponent,
		IntegrationBaseTableComponent,
		StaticFormComponent,
		CreateUpdateFormComponent,
		OutgoingEventsHybridTabsComponent
	],
	providers: [
		GenericIntegrationLoaderGuard,
		GenericIntegrationService,
		SelectedGenericIntegrationService,
		ConfirmationService,
		MessageService,
		GenericFormService
	],
	exports: [
		EditableTableComponent,
		IntegrationBaseTableComponent
	]
})
export class GenericIntegrationsModule { }
